
import { nextTick, ref, watch } from 'vue';
import { mapGetters } from 'vuex';
import { NodeType } from '@amplify/amp-module';
import NodeWrapper from '@/components/graph/common/NodeWrapper';
import { GetSelectedNodeId, GetSelectedSubNode } from '@/constants/getters';
import { useNodeUtils } from '@/composables/useNodeUtils';
import CarouselSubNode from '@/components/graph/nodes/groups/carousel/CarouselSubNode.vue';
import { getCarouselIncreaseSize } from '@/utils/builder-utils';
import { NodeSizes } from '@/constants/builder';
import { SaveSelectedNode } from '@/constants/mutations';
import { useStoreInNodes } from '@/composables/useStoreInNodes';

export default {
  components: { CarouselSubNode, NodeWrapper },

  setup() {
    const nodeType = NodeType.carousel;

    const { store } = useStoreInNodes();
    const {
      ampData,
      uiData,
      nodeId,
      nodeRef,
      nodeSelf,
      selectedSubNodeIndex,
      subNodesArray,
      canEditAmp,
      addStorageOption,
      addSubNode,
      deleteStorage,
      emitNodeRenderDoneEvent,
      onSelectSubNode,
      updateDelay,
    } = useNodeUtils({ nodeType });

    const nodeActions = [
      { key: 'right', handler: addSubNode },
      { key: 'bottom', click: true },
    ];

    const renderedCards = ref(0);

    const onCardResize = async () => {
      renderedCards.value += 1;

      // mark node as rendered after the last carousel dimensions are updated
      if (renderedCards.value === subNodesArray.value.length) {
        await nextTick();
        emitNodeRenderDoneEvent();
      }
    };

    const onUpdateSubNode = (data) => {
      const { id } = data;
      const subNodes = ampData.value.subNodes;
      subNodes[id] = data;

      ampData.value = { ...ampData.value, subNodes };
    };

    const onShowMediaPopup = (subNodeData) =>
      store.value.commit(`popupStore/${SaveSelectedNode}`, { data: subNodeData, type: nodeType });

    watch(
      ampData,
      (newObj) => {
        // resize node
        const { width } = nodeSelf.value.size();
        const increaseSize = getCarouselIncreaseSize(Object.values(newObj.subNodes || {}));

        nodeSelf.value.resize(width, NodeSizes[nodeType].height + increaseSize);
      },
      { deep: true }
    );

    return {
      ampData,
      canEditAmp,
      nodeActions,
      nodeId,
      nodeRef,
      nodeSelf,
      nodeType,
      uiData,
      selectedSubNodeIndex,
      subNodesArray,
      addStorageOption,
      deleteStorage,
      updateDelay,
      onCardResize,
      onSelectSubNode,
      onShowMediaPopup,
      onUpdateSubNode,
    };
  },

  computed: {
    ...mapGetters('builderStore', {
      selectedNodeId: GetSelectedNodeId,
      selectedSubNode: GetSelectedSubNode,
    }),
  },
};
